"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartGalleryDriver = void 0;
const abstract_1 = require("./abstract");
const contracts_1 = require("../contracts");
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
class SmartGalleryDriver extends abstract_1.AbstractTypeDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = contracts_1.RelatedType.SmartGallery;
    }
}
exports.SmartGalleryDriver = SmartGalleryDriver;
//# sourceMappingURL=smartGallery.js.map